import PropTypes from 'prop-types';
import React from 'react';

import Price from './price';

const PriceItem = ({
	className,
	classNameDiscount = 'me-2 text-gray-500',
	currency,
	price,
	price_discount,
}) => {
	return (
		<>
			{Number(price_discount) > 0 && (
				<del className={classNameDiscount}>
					<Price currency={currency} price={price} />
				</del>
			)}
			<span
				className={`${className} ${
					Number(price_discount) > 0 ? 'text-danger' : ''
				}`}
			>
				<Price
					currency={currency}
					price={Number(price_discount) > 0 ? price_discount : price}
				/>
			</span>
		</>
	);
};

PriceItem.propTypes = {
	className: PropTypes.string,
	classNameDiscount: PropTypes.string,
	currency: PropTypes.string,
	price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	price_discount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PriceItem;
